import React from 'react';
import { withRouter } from 'react-router-dom';

const NoData = props => {
    return (
        <div style={ { display: 'flex', justifyContent: 'center', flexDirection: 'column' } }>
            <div>{ props.text }</div>
            <div onClick={ () => console.log("auys") }>Go Back</div>
        </div>
    );
};

export default withRouter(NoData);